export default {
  SET_BACK (state, status) {
    state.back = status
  },
  SET_LOADER (state, status) {
    state.loader = status
  },
  SET_PAGE_LOADER (state, status) {
    state.pageLoader = status
  },
  TOGGLE_NAVIGATION_MENU (state, bool) {
    state.navigationMenu = bool
  }
}



// WEBPACK FOOTER //
// ./src/store/navigation/mutations.js